import _axios from '@/plugins/axios';

export default {
	async getTablets () {
		const response = await _axios.get('tabletinfos/getalltabletinfos');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new Error('Error geting time tracking info');
	},
};
